import { environment } from './../../environment/environment';
import request from 'umi-request';
import type { ApiResponse } from '../model/apiResponse';

export async function GetFormSection(token: string, formId: string): Promise<ApiResponse> {
  return await request('/formSection/navigation/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: formId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}


export async function GetFormSectionMenu(token: string, clientId: string): Promise<ApiResponse> {
  return await request('/formsection/menu/', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: clientId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}